const Loader = () => {
  return (
    <div data-testid="loader" className="flex h-screen items-center justify-center bg-white dark:bg-body">
      <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
    </div>
  );
};

export default Loader;
